import ReactDOM from 'react-dom/client';
import React, { useEffect, useState } from 'react';
import './index.css';
import ComboModule from './components/Combo';
import AddonModule from './components/Addon';

export const isDev = process.env.NODE_ENV === 'development';

interface Props {
  cartIconClass: string | undefined;
  shop: string;
  productId: string;
  productHandle: string;
  variantId: string;
  productTitle: string;
  hiddenClasses: string[];
  productTags: string[];
  productVariantIds: string[];
  productColourSwatches: string[];
  productImageSwatches: string[];
  shopCurrency: string;
}

const App = (props: Props) => {
  const {
    productId,
    productTags,
    shop,
    productTitle,
    productVariantIds,
    productHandle,
    cartIconClass,
    shopCurrency,
  } = props;
  const isCombo = productTags.includes('_combo');
  const [variantId, setVariantId] = useState(props.variantId);

  // monitor url changes and check for variant id from "?variant=123456789" in url
  useEffect(() => {
    // new method works on latest theme
    let oldHref = document.location.href;
    const body = document.querySelector('body');
    const observer = new MutationObserver((mutations) => {
      if (oldHref !== document.location.href) {
        oldHref = document.location.href;

        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        if (variantId) {
          setVariantId(variantId);
          // console.log('variant changed', variantId);
        }
      }
    });
    body && observer.observe(body, { childList: true, subtree: true });

    // listener method works on older themes
    const listener = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      if (variantId) {
        setVariantId(variantId);
        // console.log('variant changed', variantId);
      }
    };
    listener();
    // add listener to url changes
    window.addEventListener('locationchange', listener);
    // remove listener when component unmount
    return () => {
      window.removeEventListener('locationchange', listener);
    };
  }, []);

  return (
    <div className="rp-main-container">
      {isCombo ? (
        <ComboModule
          cartIconClass={cartIconClass}
          shop={shop}
          productId={productId}
          productTitle={productTitle}
          productColourSwatches={props.productColourSwatches}
          shopCurrency={shopCurrency}
        />
      ) : (
        <AddonModule
          shop={shop}
          cartIconClass={cartIconClass}
          productTags={productTags}
          productVariantIds={productVariantIds}
          variantId={variantId}
          productHandle={productHandle}
          hiddenClasses={props.hiddenClasses}
          productImageSwatches={props.productImageSwatches}
          shopCurrency={shopCurrency}
        />
      )}
      <div style={{ marginTop: '-2rem' }}>
        <div id="intan-button"></div>
      </div>
    </div>
  );
};

const RenderBlock = document.getElementById('react-product-module');

if (RenderBlock) {
  // @ts-ignore
  const shop = window.Shopify.shop;
  const hiddenClasses = RenderBlock.getAttribute('data-hidden-classes');
  const productId = RenderBlock.getAttribute('data-product-id');
  const productHandle = RenderBlock.getAttribute('data-product-handle');
  const variantId = RenderBlock.getAttribute('data-product-variant');
  const productTitle = RenderBlock.getAttribute('data-product-title');
  const productTags = RenderBlock.getAttribute('data-product-tags');
  const productVariants = RenderBlock.getAttribute('data-product-variants');
  const cartIconClass = RenderBlock.getAttribute('data-cart-class');
  const productColourSwatches = RenderBlock.getAttribute('data-product-colour-swatches');
  const productImageSwatches = RenderBlock.getAttribute('data-product-image-swatches');
  const shopCurrency = RenderBlock.getAttribute('data-shop-currency');

  ReactDOM.createRoot(RenderBlock).render(
    <App
      shop={shop}
      productVariantIds={(productVariants || '')
        .split(', ')
        .map((e, i) => (i === 0 ? e.slice(1) : e))}
      productTags={(productTags || '').split(', ').map((e, i) => (i === 0 ? e.slice(1) : e))}
      productId={productId || ''}
      variantId={variantId || ''}
      productTitle={productTitle || ''}
      productHandle={productHandle || ''}
      hiddenClasses={(hiddenClasses || '').split(',')}
      cartIconClass={cartIconClass || ''}
      productColourSwatches={(productColourSwatches || '').split(',')}
      productImageSwatches={(productImageSwatches || '').split(',')}
      shopCurrency={shopCurrency || ''}
    />,
  );
}
